// MB-I18N-2A — Agrégation EN (clés plates, aucune imbrication).
import admin from './admin';
import app from './app';
import auth from './auth';
import common from './common';
import crm from './crm';
import help from './help';
import os from './os';
import pos from './pos';
import wallet from './wallet';

const en = {
  ...admin,
  ...app,
  ...auth,
  ...common,
  ...crm,
  ...help,
  ...os,
  ...pos,
  ...wallet,
};

export default en;
